// SupporterBadge — 1.23.00 Phase 2. A NEW mark, deliberately NOT the
// identity checkmark (Verify): a five-point star instead of a scalloped
// badge-check silhouette, so the two are never confusable at small sizes.
// Uses currentColor like every other brand icon here — render it with an
// explicit, DIFFERENT color from wherever Verify renders (e.g. an amber/gold
// tone vs. Verify's cyan) at the call site, per the "different token colour"
// requirement. Derived server-side (has_pro(user) AND confirmed 2FA) — see
// apps.billing.entitlements.has_supporter_badge; never render this from a
// client-computed guess, only from the `supporterBadge` field the API sends.
export function SupporterBadge({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 2.5l2.7 5.8 6.3.7-4.7 4.3 1.3 6.2L12 16.4l-5.6 3.1 1.3-6.2-4.7-4.3 6.3-.7z" />
    </svg>
  );
}
